<ion-content>
  <div class="popup-container">
    <div class="popup-content">
      <div class="cloud">
        <span>{{cloudText}}</span>
      </div>
      <div class="wheel">
        <div class="element-hidden wheel-prize {{showPrize}}" *ngIf="prizeWon && render">
          <div class="wheel-prize-content">
            <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
              <circle cx="25" cy="25" r="25" [attr.fill]="prizeWon.background" />
              <text x="25" y="20" text-anchor="middle" class="small-text" font-size="6px" [attr.fill]="prizeWon.color">{{prizeWon.title}}</text>
              <text x="25" y="30" text-anchor="middle" class="big-text" font-size="12px" [attr.fill]="prizeWon.color">{{prizeWon.subtitle}}</text>
              <text x="25" y="35" text-anchor="middle" class="smallest-text" font-size="2px" [attr.fill]="prizeWon.color">{{prizeWon.text1}}</text>
              <text x="25" y="37" text-anchor="middle" class="smallest-text" font-size="2px" [attr.fill]="prizeWon.color">{{prizeWon.text2}}</text>
            </svg>
          </div>
        </div>
        <img class="knob {{rotateKnob}}" src="assets/img/fortune/arrow.svg">
        <img class="wheel-img anim--icon-{{rotateClass}}" src="assets/img/fortune/wheel.svg">
      </div>

      <div class="button-zakrec">
        <ion-button class="element-hidden" [class.active]="rotateClass=== ''" [class.disabled]="promotionCode === ''" (click)="onZakrec_click()"  [disabled]="promotionCode === ''">Zakręć</ion-button>
        <ion-button class="element-hidden quick {{showPrize}}" (click)="onClose_click()">Odbierz</ion-button>
      </div>
      <div class="tadeusz">
        <img src="assets/img/fortune/tadek100mobile.svg">
      </div>
    </div>
  </div>
</ion-content>


